"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ZoomRecordingFile () {
        return ZoomRecordingFile;
    },
    get ZoomUrlValidationResponse () {
        return ZoomUrlValidationResponse;
    },
    get ZoomWebhookObject () {
        return ZoomWebhookObject;
    },
    get ZoomWebhookPayload () {
        return ZoomWebhookPayload;
    },
    get ZoomWebhookReceivedResponse () {
        return ZoomWebhookReceivedResponse;
    },
    get ZoomWebhookResponse () {
        return ZoomWebhookResponse;
    }
});
const _zod = require("zod");
const ZoomRecordingFile = _zod.z.object({
    id: _zod.z.string().optional(),
    recording_type: _zod.z.string().optional(),
    file_type: _zod.z.string().optional(),
    download_url: _zod.z.string().optional()
}).passthrough();
const ZoomWebhookObject = _zod.z.object({
    id: _zod.z.union([
        _zod.z.string(),
        _zod.z.number()
    ]).optional(),
    uuid: _zod.z.string().optional(),
    /** TEMPORARY (PY-12508, remove in PY-12499): read only by the scope fallback. */ recording_files: _zod.z.array(ZoomRecordingFile).optional()
}).passthrough();
const ZoomWebhookPayload = _zod.z.object({
    event: _zod.z.string(),
    event_ts: _zod.z.number().optional(),
    /** TEMPORARY (PY-12508, remove in PY-12499): short-lived (~24h) JWT for downloading the event's recording files. */ download_token: _zod.z.string().optional(),
    payload: _zod.z.object({
        plainToken: _zod.z.string().optional(),
        object: ZoomWebhookObject.optional()
    }).passthrough()
});
const ZoomUrlValidationResponse = _zod.z.object({
    plainToken: _zod.z.string(),
    encryptedToken: _zod.z.string()
});
const ZoomWebhookReceivedResponse = _zod.z.object({
    received: _zod.z.boolean()
});
const ZoomWebhookResponse = _zod.z.union([
    ZoomUrlValidationResponse,
    ZoomWebhookReceivedResponse
]);
